import React from 'react';
import './styles.scss';
import Pulse from '../pulse';

const EtownHotspot = ({ data, onClickHotspot }) => {
  return (
    <div className="etown-hotspot-container" onClick={onClickHotspot}>
      <div className="etown-hotspot-hotspot"></div>
      <Pulse />
      <div className="etown-hotspot-content">
        <div className="etown-hotspot-content-title">
          <p>{data.title}</p>
        </div>
        <div className="etown-hotspot-content-image">
          <img src={data.previewImgUrl} alt={data.title} />
        </div>
      </div>
    </div>
  );
};

export default EtownHotspot;
